export const ColorScheme = {
  advanced: { color: '#7C5ABB', bg: '#F3EFFC' },
  new: { color: '#7C5ABB', bg: '#F3EFFC' },
  male: { color: '#7C5ABB', bg: '#F3EFFC' },
  cold: { color: '#7C5ABB', bg: '#F3EFFC' },
  'upper intermediate': { color: '#22C3A0', bg: '#E6F7F4' },
  female: { color: '#22C3A0', bg: '#E6F7F4' },
  contacted: { color: '#22C3A0', bg: '#E6F7F4' },
  converted: { color: '#22C3A0', bg: '#E6F7F4' },
  intermediate: { color: '#FEB366', bg: '#FFF4E6' },
  interested: { color: '#FEB366', bg: '#FFF4E6' },
  warm: { color: '#FEB366', bg: '#FFF4E6' },
  alert: { color: '#AE590A', bg: '#FDEAD8' },
  'lower intermediate': { color: '#72B2F3', bg: '#E8F4FE' },
  screened: { color: '#72B2F3', bg: '#E8F4FE' },
  beginner: { color: '#F05252', bg: '#FEE2E2' },
  enrolled: { color: '#F05252', bg: '#FEE2E2' },
  hot: { color: '#F05252', bg: '#FEE2E2' },
  in_progress: { color: '#7C5ABB', bg: '#F3EFFC' },
  submitted: { color: '#FD8100', bg: '#FFF4E6' },
  pending_approval: { color: '#5B31AA', bg: '#F3EFFC' },
  approved: { color: '#22C3A0', bg: '#E6F7F4' },
  returned: { color: '#F05252', bg: '#FEE2E2' },
  rejected: { color: '#F05252', bg: '#FEE2E2' },
  archived: { color: '#72B2F3', bg: '#E8F4FE' },
  withdrawn: { color: '#F96E6E', bg: '#FEE2E2' },
  under_review: { color: '#FEB366', bg: '#FFF4E6' },
  pending: { color: '#FEB366', bg: '#FFF4E6' },
  reassigned: { color: '#72B2F3', bg: '#E8F4FE' },
  assigned: { color: '#72B2F3', bg: '#E8F4FE' },
  upcoming: { color: '#166E3F', bg: '#D1FAE4' },
};

export const infosColorScheme = {
  ...ColorScheme,
  hot: { color: '#9A1C13', bg: '#FEE2E2' },
};

// export const ColorKeyMap = {
//   upcoming: 'upcoming',
//   hot: 'hot',
//   alert: 'alert',
//   intermediate: 'intermediate',
//   interested: 'interested',
//   warm: 'warm',
//   beginner: 'beginner',
//   enrolled: 'enrolled',
//   screened: 'screened',
//   assigned: 'assigned',
//   reassigned: 'reassigned',
//   withdrawn: 'withdrawn',
//   archived: 'archived',
//   rejected: 'rejected',
//   approved: 'approved',
//   returned: 'returned',
//   pending_approval: 'pending_approval',
//   submitted: 'submitted',
//   pending: 'pending',
//   converted: 'converted',
//   contacted: 'contacted',
//   female: 'female',
//   male: 'male',
//   advanced: 'advanced',
//   new: 'new',
//   cold: 'cold',
//   'upper intermediate': 'upper intermediate',
//   'lower intermediate': 'lower intermediate',
// };

// For backward compatibility
export const ColorsMap: Record<string, string> = Object.fromEntries(
  Object.entries(ColorScheme).map(([key, value]) => [key, value.color])
);

export const DatesOptions = [
  { label: 'All time', value: 'All_Time' },
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: '7DAYS' },
  { label: 'Last 30 Days', value: '30DAYS' },
  { label: 'This Week', value: 'This_Week' },
  { label: 'Earlier This Month', value: 'This_Month' },
];
export const DefaultDateVlue = '30DAYS';
